import type { RoomSessionView } from '../session/room-session';
import type { Navigation } from './navigation';

type Identity = Pick<RoomSessionView, 'meId' | 'roomCode' | 'roundId' | 'joined'>;

/**
 * Capture "where we are" before awaiting a dialog or the server, then ask whether the
 * world is still the same afterwards. Replaces repeated inline comparisons.
 */
export function captureContext(read: () => { navigation: Navigation; session: Identity }) {
  const before = read();
  const { meId, roomCode, roundId } = before.session;
  return {
    stillCurrent(): boolean {
      const now = read();
      return (
        now.navigation === before.navigation &&
        now.session.meId === meId &&
        now.session.roomCode === roomCode &&
        now.session.roundId === roundId &&
        now.session.joined
      );
    },
  };
}
